export class PriceFactorArgument {
  longId: number;
  priceCategoryId: number;
  productId: number;
  wm: string;
  rm: string;
  type: number;
}